import React,{useRef} from 'react'
import PropTypes from 'prop-types'
import renderHTML from 'react-render-html'

let Tooltip = (props) =>{
  const {button,description,className} = props
  const tooltipEl = useRef(null)
  if(description){
    return (
      <div className={`of-tooltip clearfix${className?' '+className:''}`} ref={tooltipEl}>
        <div className={'of-tooltip__button'}>
          {button?button:<i className={'icon-of-help text-font-3-100'}/>}
        </div>
        <div className={'of-tooltip__popup'}>
          <div className={'of-tooltip__popup-wrapper'}>
            {renderHTML(description)?renderHTML(description):<></>}
          </div>
        </div>
      </div>
    )
  }
  return (<></>)
}

Tooltip.propTypes = {
  button: PropTypes.object,
  description: PropTypes.string,
  className: PropTypes.string
}

export default Tooltip